import React from 'react';
import {Col, Container, Row, Card, CardBody, ButtonToolbar, Button} from 'reactstrap';
import {connect} from 'react-redux';
import ReactQueryParams from 'react-query-params';
import {fetchStoresByDay,prize_stores_day_update} from '../../../redux/actions/PrizeActions';
import {withRouter} from 'react-router-dom';
import Select from "../../../components/Select";
import * as TextManager from "../../../modules/languages/TextManager";
import LoadingProgress from '../../../components/LoadingProgress';

export class ChooseManager extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            manager: 0,
            managerName: ''
        };
    }

    componentDidMount() {
        //this.props.dispatch(fetchStoresByDay());
    }

    save = () => {
        this.props.chooseManager(this.state.manager, this.state.managerName);
    };

    render() {

        let isloading = this.props.utilsData.data === undefined;

        let managers = [];

        if(this.props.utilsData && this.props.utilsData.data && this.props.utilsData.data.stores) {

            for (let indx in this.props.utilsData.data.managers) {
                managers.push({value: this.props.utilsData.data.managers[indx].id, label: this.props.utilsData.data.managers[indx].name});
            }
        }

        //console.log(this.props.utilsData);

        return (

            <Row style={{flexDirection: "row-reverse"}}>
                {isloading && <Col md={4}>
                    <LoadingProgress/>
                </Col>}
                {!isloading && <Col md={4} lg={4}>
                    <Card>
                        <CardBody>
                            <div className="card__title">
                                <h5 className="bold-text">לבחור מנהל</h5>
                            </div>

                            <Select
                                style={{
                                    cursor: 'pointer',
                                    backgroundColor: '#F0F8FF',
                                    width: '100%'
                                }}
                                rtl={true}
                                name='select'
                                value={this.state.manager}
                                type={"select"}
                                select
                                options={managers}
                                onChange={(event) => {
                                    this.setState({manager: event.value, managerName: event.label});
                                }}>
                            </Select>

                            <ButtonToolbar style={{marginTop: '50px', direction: 'rtl'}}>
                                <Button color='primary' size='sm'
                                        onClick={() => this.save()}>{TextManager.getCurrentTextResource().Text.save}</Button>
                                <Button color='primary' size='sm' style={{marginRight: '20px'}}
                                        onClick={() => this.props.onClose()}>{TextManager.getCurrentTextResource().Text.cancel}</Button>
                            </ButtonToolbar>
                        </CardBody>
                    </Card>
                </Col>}
            </Row>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.prize.data,
        storesDay: state.prize.storesDay,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(ChooseManager))